export default "__VITE_ASSET__CyAneLqZ__"